import styled from "styled-components";

export const TooltipContainer = styled.div`
    display: inline-block;
    position: relative;

    .tooltip-box {
        background-color: #333;
        border-radius: 6px;
        color: white;
        padding: 5px 0;
        position: absolute;
        text-align: center;
        width: 160px;
        z-index: 1;
    }

    @keyframes fadeIn {
        to {
            opacity: 1;
        }
    }
`;